import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'; 
import { NavLink } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Table, Badge } from 'react-bootstrap';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import bclogo from "../../assets/images/logogf.png";
import'../../assets/css/client.css';
import {
    FiLogOut
} from 'react-icons/fi';
import {
    IoPersonOutline,
    IoTicketOutline
} from 'react-icons/io5';
import { Button } from 'primereact/button';

/*------------Card Icon------------*/

import { LiaTasksSolid } from "react-icons/lia";
import { GrInProgress } from "react-icons/gr";
import { MdPublishedWithChanges } from "react-icons/md";
import { TbCalendarDue } from "react-icons/tb";
import { MdOutlineConnectWithoutContact } from "react-icons/md";

import { Avatar } from 'primereact/avatar';
import { Tooltip } from 'primereact/tooltip';

function Client_dash() {

    

    return (
        <>
            <Container fluid className="mainc_body">
                <Row className='mx-0 pt-5 pt-lg-0'>
                    <Col md={6} lg={6} xs={6} className='mb-4'>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Dashboard</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                {/* <Row className="mb-4">
                    <Col lg={3} md={6} xs={6} className="px-2 mb-4 mb-lg-0">
                        <Card className="h-100">
                            <Card.Body>
                                <div className="d-flex justify-content-between">
                                    <div className='repTItle'>
                                        <span className="d-block">Completed</span>
                                        <span className="d-block h4 mt-3">17</span>
                                    </div>
                                    <div className='hrshortdata'>
                                        <span><LiaTasksSolid /></span>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={3} md={6} xs={6} className="px-2 mb-4 mb-lg-0">
                        <Card className="h-100">
                            <Card.Body>
                                <div className="d-flex justify-content-between">
                                    <div className='repTItle'>
                                        <span className="d-block">In Review</span>
                                        <span className="d-block h4 mt-3">7</span>
                                    </div>
                                    <div className='hrshortdata'>
                                        <span><GrInProgress /></span>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={3} md={6} xs={6} className="px-2 mb-4 mb-lg-0">
                        <Card className="h-100">
                            <Card.Body>
                                <div className="d-flex justify-content-between">
                                    <div className='repTItle'>
                                        <span className="d-block">In Changes</span>
                                        <span className="d-block h4 mt-3">17</span>
                                    </div>
                                    <div className='hrshortdata'>
                                        <span><MdPublishedWithChanges /></span>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={3} md={6} xs={12} className="px-2">
                        <Card>
                            <Card.Body>
                                <div className="d-flex justify-content-between">
                                    <div className='repTItle'>
                                        <span className="d-block">Contact Person</span>
                                        <span className="d-flex mt-3 align-items-center">
                                            <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/asiyajavayant.png" className="me-2" shape="circle" />
                                            <p className="mb-0">
                                                <b className="d-block mb-1">Asiya Jayavant</b>
                                                <small className="d-block">
                                                    <Tooltip target=".custom-target-icon" />
                                                    <i className="custom-target-icon pi pi-envelope text-danger"
                                                        data-pr-tooltip="asiyajavayant@gmail.com"
                                                        data-pr-position="right"
                                                        data-pr-at="right+5 top"
                                                        data-pr-my="left center-2"
                                                        style={{ cursor: 'pointer' }}>
                                                    </i>
                                                    <Tooltip target=".custom-target-icon2" />
                                                    <i className="custom-target-icon2 pi pi-phone ms-3 text-success"
                                                        data-pr-tooltip="+91 987654321"
                                                        data-pr-position="right"
                                                        data-pr-at="right+5 top"
                                                        data-pr-my="left center-2"
                                                        style={{ cursor: 'pointer' }}>
                                                    </i>
                                                </small>
                                            </p>
                                        </span>
                                    </div>
                                    <div className='hrshortdata'>
                                        <span><MdOutlineConnectWithoutContact /></span>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-4 resp_report">
                    <Card className="p-0">
                        <Card.Header className="mb-0 border-0 pt-4">
                            <h6>Due Payment</h6>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            <Table size="sm" striped>
                                <thead>
                                    <tr className="table-primary">
                                        <th>Invoice Id</th>
                                        <th>Client Name</th>
                                        <th>Company Name</th>
                                        <th>Payment Type</th>
                                        <th>Payment Date</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th style={{width: '60px'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th><Link to={''}>INV-001</Link></th>
                                        <td>John Doe</td>
                                        <td>ABC Company</td>
                                        <td>Cash</td>
                                        <td>2022-01-01</td>
                                        <td>1000</td>
                                        <td><Badge className="bg-warning">Pending</Badge></td>
                                        <td>
                                            <Button
                                                title="View"
                                                icon="pi pi-eye"
                                                outlined
                                                className="p-0 border-0"
                                                severity="help"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><Link to={''}>INV-002</Link></th>
                                        <td>John Doe</td>
                                        <td>ABC Company</td>
                                        <td>Cash</td>
                                        <td>2022-01-01</td>
                                        <td>1000</td>
                                        <td><Badge className="bg-warning">Pending</Badge></td>
                                        <td>
                                            <Button
                                                title="View"
                                                icon="pi pi-eye"
                                                outlined
                                                className="p-0 border-0"
                                                severity="help"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><Link to={''}>INV-003</Link></th>
                                        <td>John Doe</td>
                                        <td>ABC Company</td>
                                        <td>Cash</td>
                                        <td>2022-01-01</td>
                                        <td>1000</td>
                                        <td><Badge className="bg-warning">Pending</Badge></td>
                                        <td>
                                            <Button
                                                title="View"
                                                icon="pi pi-eye"
                                                outlined
                                                className="p-0 border-0"
                                                severity="help"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Row> */}
                <Row className="pb-5 mb-5 resp_report">
                    <Col lg={6} className="mb-4 mb-lg-0">
                        <Card className="h-100">
                            <Card.Header>

                            </Card.Header>
                            <Card.Body>

                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={6} className="mb-4 mb-lg-0 resp_report">
                        <Card className="h-100">
                            <Card.Header>

                            </Card.Header>
                            <Card.Body>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Client_dash;